import VinSearchSection from "./VinSearchSection";

export default VinSearchSection;
